import Audioplayer from 'umg-ember-backend/components/record-explorer/for/audioplayer';

<template>
  <Audioplayer @records={{@model}} @recordType='audioplayer' />
</template>
